import * as signalR from "@microsoft/signalr";
import  { useMemo, useState, useEffect } from 'react'




export const useSignalR = ( serverPath ) => {

    const socket = useMemo(() => new signalR.HubConnectionBuilder()
    .withUrl( serverPath ,{
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
    }).withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
            if (retryContext.elapsedMilliseconds < 25000) {
                return Math.random() * 5000;
            } else {
                return null;
            }
        }
    })
    .configureLogging(signalR.LogLevel.Information)
    .build(), [serverPath]);

    const [online, setOnline] = useState(false)


    useEffect(() => {
        if(socket) {
            socket.start()
                .then(result => {
                    console.log('conectado');
                    setOnline(true)
                })
            .catch(e => console.log('Connection failed: ', e));
        }
    },[socket])


    useEffect(() => {
        socket.onreconnecting(error => {
            console.log('Intentando reconectar');
            setOnline(false)
        });
    }, [socket]);
    
    

    return {
        socket,
        online
    }
}